import qs from '@halobear/utils/qs'

let isMiniapp = false

wx.miniProgram.getEnv((res) => {
  isMiniapp = res.miniprogram
})

export function handle401() {
  if (!isMiniapp) return
  wx.miniProgram.navigateTo({
    url: `/pages/login/index?back=back`,
  })
}

export function getIsMiniapp() {
  return isMiniapp || qs.get('from') === 'miniapp'
}
